import BaseUserJobs from './BaseUserJobs';
import { actionize, apiAction, apiFetch } from '../utils';

const duck = new BaseUserJobs('submitContractsJobs');

let types = {
  VERIFY_CONTACTS_BEGIN: null,
  VERIFY_CONTACTS_SUCCESS: null,
  VERIFY_CONTACTS_ERROR: null
};

types = actionize(types, (action) => `schooladmin/submitContractsJob/${action}`);

/**
 * Determines which contacts we can actually submit contracts for.
 */
const verifyContacts = (ids, schoolYearId) => apiAction(
  types.VERIFY_CONTACTS_BEGIN,
  types.VERIFY_CONTACTS_SUCCESS,
  types.VERIFY_CONTACTS_ERROR,
  (state) => apiFetch.post(
    state,
    `${duck.config.collectionApiPath()}/verify`,
    {
      contact_ids: ids,
      school_year_id: schoolYearId
    }
  )
);

export const entity = {
  ...duck,
  actions: {
    ...duck.actions,
    verifyContacts
  }
};
